import { Injectable } from '@angular/core';
import { RegistrationFacade } from '@us-registration/data-access';
import { Observable, combineLatest, map } from 'rxjs';

export interface ViewModel {
  hasRegisteredItemOutOfGuarantee: boolean;
}

@Injectable()
export class RegistrationWarrantyNotePanelComponentService {
  private readonly quoteOutOfGuarantee$: Observable<boolean> =
    this.registrationFacade.hasRegisteredItemOutOfGuarantee$.pipe(
      map(
        (hasRegisteredItemOutOfGuarantee) =>
          hasRegisteredItemOutOfGuarantee ||
          localStorage.getItem('quoteOutOfGuarantee') === 'true'
      )
    );

  readonly vm$: Observable<ViewModel> = combineLatest({
    hasRegisteredItemOutOfGuarantee: this.quoteOutOfGuarantee$,
  });

  constructor(private readonly registrationFacade: RegistrationFacade) {}
}
